import {
  Datatype,
  PlainDatatype,
} from '../../../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { IPaymentRowWidget } from './IPaymentRowWidget';
import {
  getPaymentRowKey,
  PaymentRowFieldKey,
} from './createPaymentRowFormSchema';

function createFieldReference(params: {
  widget: IPaymentRowWidget;
  path: IReferencePath;
  field: PaymentRowFieldKey;
  description: string;
  datatype: PlainDatatype;
}): IReference {
  const { widget, path, field, description, datatype } = params;

  return {
    type: ReferenceType.Widget,
    widgetType: null,
    id: `${widget.id}-${field}`,
    code: getPaymentRowKey(widget.code, field),
    path,
    field: { type: datatype },
    label: `${widget.code}: ${description}`,
  };
}

/**
 * Restituisce le reference del widget Voce di Costo.
 * Il widget non ha "un valore", ma è un'insieme di campi (descrizione, importo, iva, ecc).
 * Non ha quindi
 */
export function getPaymentRowReferences(
  path: IReferencePath,
  widget: IPaymentRowWidget,
): IReference[] {
  return [
    // Descrizione
    createFieldReference({
      widget,
      path,
      field: 'description',
      description: 'Descrizione',
      datatype: Datatype.String,
    }),
    // Importo
    createFieldReference({
      widget,
      path,
      field: 'baseUnitAmount',
      description: 'Importo Unitario',
      datatype: Datatype.Number,
    }),
    // Iva
    createFieldReference({
      widget,
      path,
      field: 'vat',
      description: 'IVA',
      datatype: Datatype.Number,
    }),
    // Quantità
    createFieldReference({
      widget,
      path,
      field: 'quantity',
      description: 'Quantità',
      datatype: Datatype.Number,
    }),
    // Unità di misura
    createFieldReference({
      widget,
      path,
      field: 'unit',
      description: 'Unità di Misura',
      datatype: Datatype.String,
    }),
    // Sconto
    createFieldReference({
      widget,
      path,
      field: 'discount',
      description: 'Sconto/Esenzione',
      datatype: Datatype.Number,
    }),
    // Imponibile
    {
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-taxable`,
      code: `${widget.code}@taxable`,
      path,
      field: { type: Datatype.Number },
      label: `${widget.code}: Imponibile`,
    },
    // IVA
    {
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-vat`,
      code: `${widget.code}@vatAmount`,
      path,
      field: { type: Datatype.Number },
      label: `${widget.code}: Importo IVA`,
    },
    // Totale
    // È possibile fare riferimento al totale sia come reference al widget (widget.code) sia
    // con questa reference specifica (così che l'utente sia più chiaro che si tratta del totale).
    {
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-total`,
      code: `${widget.code}`,
      path,
      field: { type: Datatype.Number },
      label: `${widget.code}: Totale`,
    },
  ];
}
